// local
import { baseFetch } from '../../baseFetch';
import {
  GetSolarFarmByUuidResponseSchema,
  SolarFarmSearchResponseSchema,
  UpdateSolarFarmPayload,
  UpdateSolarFarmResponseSchema,
} from './solar-farm.schema';

export const getSolarFarmsByName = (
  name: string,
  { signal }: { signal: AbortSignal | undefined },
) => {
  return baseFetch(
    'internal-v2',
    '/solar_farms',
    SolarFarmSearchResponseSchema,
    {
      searchParams: {
        name,
      },
      abortSignal: signal,
    },
  );
};

export const getSolarFarmByUuid = (solar_farm_uuid: string) => {
  return baseFetch(
    'internal-v2',
    `/solar_farms/${solar_farm_uuid}`,
    GetSolarFarmByUuidResponseSchema,
  );
};

export const updateSolarFarmByUuid = (
  uuid: string,
  orgId: number,
  payload: UpdateSolarFarmPayload,
) => {
  return baseFetch(
    'customer-farm-api',
    `/solar_farms/${uuid}`,
    UpdateSolarFarmResponseSchema,
    {
      method: 'PUT',
      requestBody: payload,
      searchParams: { org_id: String(orgId) },
    },
  );
};
